import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
// TODO: Error al declarar el modulo

createApp(App).use(router).mount('#app')
